import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b654b5a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex__column--center" }
const _hoisted_2 = { class: "app__property--medium" }
const _hoisted_3 = { class: "ecran-container" }
const _hoisted_4 = {
  key: 0,
  class: "ecran__details",
  style: {"position":"relative"}
}
const _hoisted_5 = {
  key: 0,
  class: "card__debitare__options"
}
const _hoisted_6 = { style: {"grid-area":"toggledebit"} }
const _hoisted_7 = { style: {"grid-area":"nrbuc"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"1.2rem"} }, "Nr.Bucati", -1))
const _hoisted_9 = {
  key: 0,
  class: "cutting-length-width",
  style: {"grid-area":"lungimelatime"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"1.2rem"} }, "Lungime(mm)", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"1.2rem"} }, "Latime(mm)", -1))
const _hoisted_14 = { style: {"display":"flex","justify-content":"flex-start","padding-top":"2rem","padding-bottom":"2rem","padding-right":"2px","min-height":"7rem"} }
const _hoisted_15 = { style: {"font-weight":"bold","font-size":"1.2rem"} }
const _hoisted_16 = { style: {"font-weight":"bold","font-size":"1.2rem"} }
const _hoisted_17 = {
  key: 2,
  style: {"margin-left":"24px","margin-top":"-20px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-align":"center","display":"flex","align-items":"center"} }, "Tip UM dorit la ofetare", -1))
const _hoisted_19 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_20 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column","align-items":"center"}
}
const _hoisted_21 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column","align-items":"center"}
}
const _hoisted_22 = {
  key: 1,
  style: {"margin-left":"24px","margin-top":"-20px"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-align":"center","display":"flex","align-items":"center"} }, "Tip UM dorit la ofetare", -1))
const _hoisted_24 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_25 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column","align-items":"center"}
}
const _hoisted_26 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column","align-items":"center"}
}
const _hoisted_27 = { style: {"display":"flex","flex-direction":"column","padding-top":"2rem","padding-bottom":"2rem","padding-right":"2rem"} }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app__label--medium" }, "Observatii:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = { class: "div__btn" }
const _hoisted_32 = {
  key: 1,
  class: "app__label--medium"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ne pare rau, dar a survenit o eroare! Articolul nu poate fi dentificat in baza de date! Redeschideti aplicatia si incercati din nou. Daca eroarea persista va rugam sa contactati Area Sales Manager!", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Multumim!", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.productName), 1),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.ArticolIdentificatInBazaDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.selectedSize.cuDebitare)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_q_toggle, {
                        modelValue: _ctx.dorescDebitare,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dorescDebitare) = $event)),
                          _ctx.punePeZeroDimensiuni
                        ],
                        label: "Doresc Debitare"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.selectedSize.cuDebitare && _ctx.dorescDebitare)
                        ? (_openBlock(), _createBlock(_component_q_input, {
                            key: 0,
                            modelValue: _ctx.nrBucati,
                            "onUpdate:modelValue": [
                              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nrBucati) = $event)),
                              _ctx.coreleazaUm1Um2CuDebitare
                            ],
                            modelModifiers: { number: true },
                            type: "number",
                            outlined: "",
                            "label-slot": "",
                            min: "0",
                            max: "10000",
                            style: {"max-width":"200px","padding-left":"1rem"}
                          }, {
                            label: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.selectedSize.cuDebitare && _ctx.dorescDebitare)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.cuttingLength,
                            "onUpdate:modelValue": [
                              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cuttingLength) = $event)),
                              _ctx.coreleazaUm1Um2CuDebitare
                            ],
                            modelModifiers: { number: true },
                            type: "number",
                            min: "0",
                            max: "3020",
                            outlined: "",
                            "label-slot": "",
                            style: {"min-width":"15rem","max-width":"15rem"},
                            error: _ctx.ErrorRuleLengthDebitarePlaca
                          }, {
                            label: _withCtx(() => [
                              _hoisted_10
                            ]),
                            error: _withCtx(() => [
                              (_ctx.typeOfArticle==='placa')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Lungimea admisa intre " + _toDisplayString(_ctx.minLengthPlaci) + "mm si" + _toDisplayString(_ctx.maxLengthPlaci) + "mm", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_12, "Latimea admisa intre " + _toDisplayString(_ctx.minLengthBare) + "mm si " + _toDisplayString(_ctx.maxLengthBare) + "mm", 1))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onUpdate:modelValue", "error"]),
                          (_ctx.typeOfArticle==='placa')
                            ? (_openBlock(), _createBlock(_component_q_input, {
                                key: 0,
                                modelValue: _ctx.cuttingWidth,
                                "onUpdate:modelValue": [
                                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cuttingWidth) = $event)),
                                  _ctx.coreleazaUm1Um2CuDebitare
                                ],
                                modelModifiers: { number: true },
                                type: "number",
                                min: "0",
                                max: "3020",
                                outlined: "",
                                "label-slot": "",
                                style: {"min-width":"15rem","max-width":"15rem"},
                                error: _ctx.ErrorRuleWidthDebitarePlaca
                              }, {
                                label: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                error: _withCtx(() => [
                                  _createElementVNode("span", null, "Latimea admisa intre " + _toDisplayString(_ctx.minLengthPlaci) + "mm si " + _toDisplayString(_ctx.maxLengthPlaci) + "mm", 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onUpdate:modelValue", "error"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.selectedSize.um1 && _ctx.selectedSize.um1.length>0 && !_ctx.HideUm1IfBucDebit)
                  ? (_openBlock(), _createBlock(_component_q_input, {
                      key: 0,
                      modelValue: _ctx.qUm1,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.qUm1) = $event)),
                        _cache[5] || (_cache[5] = ($event: any) => (_ctx.coreleazaUm1Um2('um1')))
                      ],
                      modelModifiers: { number: true },
                      type: "number",
                      readonly: _ctx.selectedSize.cuDebitare && _ctx.dorescDebitare,
                      outlined: "",
                      "label-slot": "",
                      style: {"max-width":"7rem"}
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.selectedSize.um1), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "readonly"]))
                  : _createCommentVNode("", true),
                (_ctx.selectedSize.um2 && _ctx.selectedSize.um2.length>0 && !_ctx.HideUm2IfBucDebit)
                  ? (_openBlock(), _createBlock(_component_q_input, {
                      key: 1,
                      modelValue: _ctx.qUm2,
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => ((_ctx.qUm2) = $event)),
                        _cache[7] || (_cache[7] = ($event: any) => (_ctx.coreleazaUm1Um2('um2')))
                      ],
                      modelModifiers: { number: true },
                      type: "number",
                      readonly: _ctx.selectedSize.cuDebitare && _ctx.dorescDebitare,
                      outlined: "",
                      "label-slot": "",
                      style: {"max-width":"7rem","margin-left":"1rem"}
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.selectedSize.um2), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "readonly"]))
                  : _createCommentVNode("", true),
                ((_ctx.selectedSize.um1 || _ctx.selectedSize.um2) && _ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        ((!_ctx.HideUm1IfBucDebit || _ctx.dorescDebitare) && (_ctx.selectedSize.um1 != '' && _ctx.selectedSize.um1 != null))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createTextVNode(_toDisplayString(_ctx.selectedSize.um1) + " ", 1),
                              _createVNode(_component_q_checkbox, {
                                size: "xl",
                                modelValue: _ctx.selectedUM1,
                                "onUpdate:modelValue": [
                                  _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedUM1) = $event)),
                                  _cache[9] || (_cache[9] = val => _ctx.changeTipUm(val, 1))
                                ]
                              }, null, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true),
                        ((!_ctx.HideUm2IfBucDebit || _ctx.dorescDebitare) && (_ctx.selectedSize.um2 != '' && _ctx.selectedSize.um2 != null))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createTextVNode(_toDisplayString(_ctx.selectedSize.um2) + " ", 1),
                              _createVNode(_component_q_checkbox, {
                                size: "xl",
                                modelValue: _ctx.selectedUM2,
                                "onUpdate:modelValue": [
                                  _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedUM2) = $event)),
                                  _cache[11] || (_cache[11] = val => _ctx.changeTipUm(val, 2))
                                ]
                              }, null, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              ((_ctx.selectedSize.um1 || _ctx.selectedSize.um2) && _ctx.$q.platform.is.mobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      ((!_ctx.HideUm1IfBucDebit || _ctx.dorescDebitare) && (_ctx.selectedSize.um1 != '' && _ctx.selectedSize.um1 != null))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createTextVNode(_toDisplayString(_ctx.selectedSize.um1) + " ", 1),
                            _createVNode(_component_q_checkbox, {
                              size: "xl",
                              modelValue: _ctx.selectedUM1,
                              "onUpdate:modelValue": [
                                _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedUM1) = $event)),
                                _cache[13] || (_cache[13] = val => _ctx.changeTipUm(val, 1))
                              ]
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      ((!_ctx.HideUm2IfBucDebit || _ctx.dorescDebitare) && (_ctx.selectedSize.um2 != '' && _ctx.selectedSize.um2 != null))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createTextVNode(_toDisplayString(_ctx.selectedSize.um2) + " ", 1),
                            _createVNode(_component_q_checkbox, {
                              size: "xl",
                              modelValue: _ctx.selectedUM2,
                              "onUpdate:modelValue": [
                                _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedUM2) = $event)),
                                _cache[15] || (_cache[15] = val => _ctx.changeTipUm(val, 2))
                              ]
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_q_input, {
                  maxlength: _ctx.selectedSize.cuDebitare && _ctx.dorescDebitare ? '20' : '200',
                  type: "textarea",
                  autogrow: "",
                  counter: "",
                  class: "input--desire",
                  outlined: "",
                  modelValue: _ctx.inputFreeTextComments,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.inputFreeTextComments) = $event)),
                  placeholder: "Scrie-ne cu ce te putem ajuta ",
                  dense: "",
                  color: "blue-grey-7"
                }, null, 8, ["maxlength", "modelValue"])
              ]),
              _hoisted_29,
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _withDirectives(_createVNode(_component_q_btn, {
                  "no-caps": "",
                  label: "renunt"
                }, null, 512), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  color: 'blue',
                  icon: "shopping_cart",
                  "no-caps": "",
                  label: "Salveaza",
                  style: {"margin-left":"5px"},
                  onClick: _ctx.editProductInOffer
                }, null, 8, ["onClick"]), [
                  [_directive_close_popup]
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35))
      ])
    ])
  ]))
}